import { wrapIndex } from "appworks/utils/collection-utils";
import { RandomRangeInt } from "appworks/utils/math/random";
import { ReelSubcomponent } from "slotworks/components/matrix/reel/reel-subcomponent";
import { ReelstripPosition } from "./reel-spinner";
import { ReelSpinnerResultBuffer } from "./reel-spinner-result-buffer";

export class AlternatingBlankReelSpinnerResultBuffer implements ReelSpinnerResultBuffer {

    protected reel: ReelSubcomponent;

    protected blankSymbols: string[] = ["blank", "BL"];

    public init(reel: ReelSubcomponent) {
        this.reel = reel;
    }

    public isBlank(symbol: string) {
        return this.blankSymbols.indexOf(symbol) !== -1;
    }

    public getBufferSize(result: ReelstripPosition, current: ReelstripPosition): number {
        const currentSymbolIsBlank = this.isBlank(wrapIndex(current.index, current.reelstrip));
        const lastResultSymbolIsBlank = this.isBlank(wrapIndex(result.index + (this.reel.size), result.reelstrip));
        
        return (currentSymbolIsBlank === lastResultSymbolIsBlank) ? 4 : 5;
    }

    public generateResultBuffer(incoming: string[], result: ReelstripPosition, current: ReelstripPosition) {
        // This is unnecessary now. We use the true strips and guarantee that the incoming symbols do not contain
        // repeated blanks or repeated non-blanks.

        /*
        const activeBlankSymbol = current.reelstrip.find((item) => this.blankSymbols.indexOf(item) !== -1);
        const replacementSymbol = "N"; // TODO: select replacement in a less dumb way.

        const topHiddenIndex = 0;
        const topGridIndex = 1;
        const bottomGridIndex = incoming.length - 3; // TODO: calculate based on grid height. This assumes a static buffer size of 2.
        const bottomHiddenIndex = incoming.length - 2;

        // Fix top hidden symbol if needed.
        const topHiddenBlank = this.isBlank(incoming[topHiddenIndex]);
        const topGridBlank = this.isBlank(incoming[topGridIndex]);
        if (topHiddenBlank === topGridBlank) {
            // Non-alternating blanks detected. Need to change first symbol.
            incoming[topHiddenIndex] = topHiddenBlank ? replacementSymbol : activeBlankSymbol;
        }

        // Fix bottom hidden symbol if needed.
        const bottomGridBlank = this.isBlank(incoming[bottomGridIndex]);
        const bottomHiddenBlank = this.isBlank(incoming[bottomHiddenIndex]);
        if (bottomGridBlank === bottomHiddenBlank) {
            // Non-alternating blanks detected. Need to change first symbol.
            incoming[bottomHiddenIndex] = bottomHiddenBlank ? replacementSymbol : activeBlankSymbol;
        }
        return;
        */
    }

    public generateStartBuffer(spinReelstrip: ReelstripPosition, currentView: string[]): string[] {
        const activeBlankSymbol = spinReelstrip.reelstrip.find((item) => this.blankSymbols.indexOf(item) !== -1);
        let replacementSymbol = wrapIndex(spinReelstrip.index + currentView.length - 1, spinReelstrip.reelstrip);

        if(this.blankSymbols.indexOf(replacementSymbol) !== -1) {
            replacementSymbol = wrapIndex(spinReelstrip.index + currentView.length, spinReelstrip.reelstrip);
        }

        const reelConnectIndex = wrapIndex(spinReelstrip.index - 2, spinReelstrip.reelstrip);
        const gridConnectIndex = wrapIndex(spinReelstrip.index - 1, spinReelstrip.reelstrip);
        const reelConnectBlank = this.isBlank(spinReelstrip.reelstrip[reelConnectIndex]);
        const gridConnectBlank = this.isBlank(spinReelstrip.reelstrip[gridConnectIndex]);

        const buffer = [];
        if (reelConnectBlank === gridConnectBlank) {
            buffer.push(reelConnectBlank ? replacementSymbol : activeBlankSymbol);
        }

        return buffer;
    }

    public getRandomStartPosition(reelstrip: string[], currentView: string[]): number {

        const currentTopSymbolIsBlank = this.isBlank(currentView[0]);

        while (true) {
            const index = RandomRangeInt(0, reelstrip.length - 1);
            const nextSymbol = wrapIndex(index + this.reel.size, reelstrip);
            if (currentTopSymbolIsBlank !== this.isBlank(nextSymbol)) {
                return index;
            }
        }
    }
}
